'use client';

import Link from 'next/link';

import { MAIL_CONFIG, SOCIAL_CONFIG } from '../constants';

import EnvelopeFill from '@/assets/icons/iconEnvelopeFill.svg';
import IconMax from '@/assets/icons/iconMax.svg';
import { MaskedPhone } from '@/shared/components/maskedPhone';
import { useGetClientHost } from '@/shared/hooks';
import { TranslatedComponent } from '@/shared/types';
import { getDomainKey } from '@/shared/utils/getDomainInfo';

export const ContactsRuMobile = ({ translations }: TranslatedComponent) => {
  const clientHost = useGetClientHost();
  const email = MAIL_CONFIG[getDomainKey(clientHost)];

  return (
    <section
      id="contacts"
      className="mt-7 flex flex-col items-start gap-y-[56px] rounded-none p-0"
    >
      <MaskedPhone
        phoneNumber={translations.contactsPhoneLocale}
        message={translations.formPhoneConsentMessage}
        loadingMessage={translations.loadingMessage}
      />

      <div className="flex gap-2 text-white/20 opacity-65">
        <Link href={SOCIAL_CONFIG.ru.max} target="_blank" aria-label="max">
          <IconMax />
        </Link>
        <Link href={`mailto:${translations.contactsEmail}`} aria-label="email">
          <EnvelopeFill />
        </Link>
      </div>

      <Link
        href={`mailto:${email}`}
        className="text-[20px] leading-[32px]"
        aria-label={email}
      >
        {email}
      </Link>
    </section>
  );
};
